import axios from '@/plugins/w/axios/models/axios'
import _ from 'lodash'
import { buildQueryFilters, createApiHook } from '@/plugins/app/api'
export interface LisPatientsFilters {
	search?: string
}

export const QUERY_KEY = 'lis-patients'

export const DEFAULT_FILTERS: LisPatientsFilters = {
	search: ''
}

export const fetchFn = async (pagination: Pagination, filters: LisPatientsFilters = {}) => {
	const query = fetchQuery(pagination, filters)
	const params = buildQueryFilters(query)

	return axios.get_auth(`v1/oc/patients?${params}`).catch((error) => Promise.reject(error.response || error))
}

export const fetchQuery = (pagination: Pagination, filters: LisPatientsFilters) => {
	const filtersWithDefaults = _.defaults(filters, DEFAULT_FILTERS)

	const query = {
		per_page: Number(pagination.per_page),
        page: Number(pagination.current_page),
		search: filtersWithDefaults.search?.trim() || ''
	}

	return query
}

export const useGetLisPatients = createApiHook(fetchFn, QUERY_KEY, fetchQuery)
